import { gql, useMutation } from "@apollo/client";

import {
  BatchCreateCollectionAssetsInput,
  CreateCollectionAssetsInput,
  DeleteCollectionAssetsInput,
} from "../../../generated/gql/graphql";

const CREATE_COLLECTION_ASSETS = gql`
  mutation CreateCollectionAssets($input: CreateCollectionAssetsInput!) {
    createCollectionAssets(input: $input)
  }
`;

const BATCH_CREATE_COLLECTION_ASSETS = gql`
  mutation BatchCreateCollectionAssets(
    $input: BatchCreateCollectionAssetsInput!
  ) {
    batchCreateCollectionAssets(input: $input)
  }
`;

const DELETE_COLLECTION_ASSETS = gql`
  mutation DeleteCollectionAssets($input: DeleteCollectionAssetsInput!) {
    deleteCollectionAssets(input: $input)
  }
`;

type CollectionAssetsMutationApi = {
  createCollectionAssets(input: CreateCollectionAssetsInput): Promise<void>;
  batchCreateCollectionAssets(
    input: BatchCreateCollectionAssetsInput
  ): Promise<void>;
  deleteCollectionAssets(input: DeleteCollectionAssetsInput): Promise<void>;
};

export default function useCollectionAssets(): CollectionAssetsMutationApi {
  const [batchAddAssetsToCollectionMut] =
    useMutation<BatchCreateCollectionAssetsInput>(
      BATCH_CREATE_COLLECTION_ASSETS
    );
  const [addAssetsToCollectionMut] = useMutation<CreateCollectionAssetsInput>(
    CREATE_COLLECTION_ASSETS
  );
  const [deleteCollectionAssetsMut] = useMutation<DeleteCollectionAssetsInput>(
    DELETE_COLLECTION_ASSETS
  );

  async function createCollectionAssets(
    input: CreateCollectionAssetsInput
  ): Promise<void> {
    await addAssetsToCollectionMut({
      variables: {
        input,
      },
    });
  }

  async function batchCreateCollectionAssets(
    input: BatchCreateCollectionAssetsInput
  ): Promise<void> {
    await batchAddAssetsToCollectionMut({
      variables: {
        input,
      },
    });
  }

  async function deleteCollectionAssets(
    input: DeleteCollectionAssetsInput
  ): Promise<void> {
    await deleteCollectionAssetsMut({
      variables: {
        input,
      },
    });
  }

  return {
    createCollectionAssets,
    batchCreateCollectionAssets,
    deleteCollectionAssets,
  };
}
